export default __webpack_public_path__ + "static/media/adminIcon.9726f59e.svg";